import React from 'react';
import GenericSectionDashboard from '../GenericSectionDashboard';

const ITGoodsDashboard = () => {
  return (
    <GenericSectionDashboard
      sectionName="IT Goods"
      sectionId="it-goods"
      sectionKey="IT Goods"
      description="IT Equipment Inventory & Tracking"
      backRoute="/"
    />
  );
};

export default ITGoodsDashboard;
